import { GetYear } from '../Functions/GetDates.js';

export const FilterHistoryYears = (datas) => {
    const collection = [];
    const map = new Map();
    let year;
    if (!datas.errno) {
        for (let i = 0; i < datas.length; i ++) {
            year = GetYear(datas[i].created);
            if (!map.has(year)) {
                map.set(year, true);
                collection[i] = year;
            }
        }
    }
    return collection;
}
